import { createSelector } from 'reselect'

import { SharedState } from '~shared-components/redux/sharedState'

export const selectSearchState = (state: SharedState) => state.search

export const query = createSelector([selectSearchState], state => state.query)
export const input = createSelector([selectSearchState], state => state.input)

export const SearchSelector = {
  input,
  query,
}
